import React, {useState} from "react";
import {BillingAccountType, TransAccount} from "@/common/dto/TransAccount";
import {accountTypeNames} from "@/constatants";
import {FtDialog} from "@/common/FtDialog";
import {InputWrap} from "@/component/input/InputWrap";
import {StringInput} from "@/component/input/StringInput";
import {FtSelect} from "@/component/input/FtSelect";
import {AmountInput} from "@/component/input/AmountInput";
import {FtSwitch} from "@/component/input/FtSwitch";
import {FtButton} from "@/common/FtButton";
import {useAccountStore} from "@/store/useAccountStore";
import {AccountData} from "@/common/req/AccountData";

interface Props {
    show: boolean;
    account: TransAccount;
    onHide: () => void;
}

export function EditAccountDialog(props: Props) {
    const {account} = props;
    const [data, setData] = useState<AccountData>({
        name: account.name,
        type: account.type,
        startAmount: account.startAmount,
        detail: account.detail,
        archived: account.archived,
    });
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);
    const updateAccount = useAccountStore(state => state.updateAccount);

    const handleSubmit = async () => {
        try {
            setLoading(true);
            setError(null);
            await updateAccount(account.id, data);
            props.onHide();
        } catch (err) {
            setError(err instanceof Error ? err.message : "An error occurred");
        } finally {
            setLoading(false);
        }
    };

    return (
        <FtDialog handleClose={props.onHide} title="계정 수정">
            {error && (
                <div style={{margin: "8px 0", padding: "8px", color: "red"}}>
                    Error: {error}
                </div>
            )}

            <InputWrap label="계정 이름">
                <StringInput
                    fullWidth
                    placeholder="계정 이름"
                    value={data.name}
                    onChange={v => setData({...account, name: v})}
                />
            </InputWrap>

            <InputWrap label="계정 유형">
                <FtSelect
                    width="100%"
                    value={data.type}
                    values={Object.keys(accountTypeNames)}
                    labels={Object.values(accountTypeNames)}
                    onChange={v => setData({...account, type: v as BillingAccountType})}
                />
            </InputWrap>

            <InputWrap label="시작 금액">
                <AmountInput
                    value={data.startAmount}
                    fullWidth
                    onChange={v => setData({...account, startAmount: v})}
                />
            </InputWrap>

            <InputWrap label="상세 설명">
                <StringInput
                    fullWidth
                    placeholder="상세 설명"
                    value={data.detail}
                    onChange={v => setData({...account, detail: v})}
                />
            </InputWrap>

            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, marginBottom: 16}}>
                <div>
                    <FtSwitch label="미사용" checked={data.archived}
                              onChange={v => setData({...account, archived: v})}/>
                </div>

                <div>
                    <FtButton
                        onClick={handleSubmit}
                        variant="contained"
                        style={{minWidth: 80}}
                        disabled={loading}
                    >
                        {loading ? "저장 중..." : "저장"}
                    </FtButton>
                </div>
            </div>

        </FtDialog>
    );
}
